HuesMdl.directive( 'singleHue', [ '$document', '$templateCache', '$state', 'UtilsSrv', 'RedirectSrv', function( $document, $templateCache, $state, UtilsSrv, RedirectSrv ) {
	return {
		restrict: 'E',
		replace: true,
		template: $templateCache.get('Hues/Single/_single-hue.tpl.html'),
		link: function( scope, element ){

			console.log(RedirectSrv.getRedirect());

			scope.$parent.hue.redirect = RedirectSrv.getRedirect();


			/**
			 * Scroll to open single hue:
			 */
			UtilsSrv.scrollHandler.disableScroll();
			$('html, body').animate({ scrollTop: element.offset().top }, 800, function(){
				UtilsSrv.scrollHandler.enableScroll();
			});



			/**
			 * Exit Single State:
			 */
			function exitSingle( chosenHue ) {
				chosenHue = chosenHue || element.parent('.chosen');

				UtilsSrv.scrollHandler.disableScroll();
				$('html, body').animate({ scrollTop: chosenHue.offset().top }, 800, function(){
					UtilsSrv.scrollHandler.enableScroll();
				});

				//If we to exit from single hue, navigate to relative parent:
				$state.go('^');
			}


			$document.on("keydown keypress", function ( e ) {
				if( $('#overlay').css('display') === 'flex' )
					return;

				if( e.which === 27)
					exitSingle( angular.element( document.querySelector('.fan.archive.item-wrapper.chosen') ) );

				return;
			});

			element.find('.close-hue .na-close').on('click', function(){
				exitSingle();
			});

		}
	}
}]);
